import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Injectable({
		providedIn: 'root'
	}
)
export class TooltipService {
	component: any;

	constructor(private translateSvc: TranslateService) {}

	addTooltip(component: any) {
		this.component = component;
	}

	getTooltipItem(labelName: string) {
		const translateObject = this.translateSvc.instant(labelName);
		return {
			name: translateObject.name ? translateObject.name : '',
			title: translateObject.title ? translateObject.title : '',
			content: translateObject.content ? translateObject.content : '',
			help: translateObject.help ? translateObject.help : ''
		};
	}

	destroy() {
		if (this.component) {
			this.component.destroy();
		}
	}
}
